export const DOLLARS_TO_POINTS_COEFFICIENT = 1000
